<template>
    <div class="404">
        <h1>404</h1>
        <h2>页面未找到</h2>
        <div class="errorLine"></div>
        <p class="backHomeBox">
            <router-link to="/home" class="backHome">返回首页</router-link>
        </p>
    </div>
</template>
<script>
export default {};
</script>
<style scoped>
h1 {
    font-size: 120px;
    text-align: center;
    font-family: "黑体";
    padding: 60px 0 30px 0;
}
h2 {
    font-size: 50px;
    text-align: center;
    font-family: "黑体";
    padding: 30px;
}
.errorLine {
    width: 60%;
    margin: 0 auto;
    margin-top: 150px;
    border-top: 1px solid #333;
}
.backHomeBox {
    display: block;
    padding: 50px 0;
    text-align: center;
    margin: 0 auto;
}
</style>
